<template>
  <div>
    <breadcrumbs class="bg-light text-muted"></breadcrumbs>
    <div class="p-5 bg-white rounded">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/common/Breadcrumbs'

  export default {
    metaInfo: {
      title: 'Settings'
    },
    components: {
      'breadcrumbs': Breadcrumbs
    }
  }
</script>
